<template>
  <li class="sidebar__tasks-item">
    <a href="/tasks/" class="sidebar__tasks-link">
      Задачи 
      <span v-if="count" class="sidebar__tasks-count">{{count}}</span>
    </a>
  </li>
</template>

<script>
export default {
  computed: {
    count() {
      return this.$store.getters.tasksNotifications.length;
    }
  }
};
</script>
